import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@ncoder/ui";
import { Badge } from "@ncoder/ui";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface ToolCardProps {
  id: string;
  title: string;
  description: string;
  icon: React.ElementType;
  color: string;
  category: string;
  difficulty: string;
  estimatedTime: string;
  isSelected?: boolean;
  onClick: () => void;
}

const difficultyColors: Record<string, string> = {
  Beginner: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  Intermediate:
    "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
  Advanced: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
};

export const ToolCard: React.FC<ToolCardProps> = ({
  title,
  description,
  icon: Icon,
  color,
  category,
  difficulty,
  estimatedTime,
  isSelected = false,
  onClick,
}) => {
  return (
    <Card
      onClick={onClick}
      className={cn(
        "cursor-pointer transition-all hover:shadow-lg hover:scale-105",
        isSelected && "ring-2 ring-primary bg-primary/5"
      )}
    >
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div
            className={`w-12 h-12 bg-gradient-to-r ${color} rounded-lg flex items-center justify-center mb-3`}
          >
            <Icon className="h-6 w-6 text-white" />
          </div>
          <div className="flex flex-col items-end gap-2">
            {isSelected && <Check className="h-5 w-5 text-primary" />}
            <Badge className={difficultyColors[difficulty] || ""}>
              {difficulty}
            </Badge>
          </div>
        </div>
        <CardTitle className="text-lg">{title}</CardTitle>
        <CardDescription className="text-sm">{description}</CardDescription>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Est. Time:</span>
            <span className="font-medium">{estimatedTime}</span>
          </div>
          <div className="flex items-center justify-between">
            <Badge variant="outline">{category}</Badge>
            {isSelected ? (
              <Badge variant="default" className="bg-primary">
                Selected
              </Badge>
            ) : (
              <span className="text-xs text-muted-foreground">
                Click to select
              </span>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
